import type { AppRedirect } from 'src/shared/routes';

// TODO move to nginx?
export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/p/:slug/psf/start-a-local-petition',
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		buildUrl: ({ params: { slug }, queryString }) => `/p/${slug!}/d${queryString}`,
		reason: 'deprecated-url',
	},
];
